<div class="p-4 d-flex flex-column justify-content-center align-items-center text-center easter-egg-content">
  <h2 mat-dialog-title class="easter-egg-title mb-3">Bzz Bzz</h2>
  <span class="bee-icon mb-3">🐝</span>
  <p class="mb-4">Realizzata con amore per lavoratori instancabili!</p>

  <button mat-raised-button color="primary" mat-dialog-close>
    Ok!
  </button>
</div>
